module.exports = __webpack_public_path__ + "static/media/logo_macizo1.ac6929d4.png";